import { mdiAccount, mdiCart, mdiWeb } from '@mdi/js'
import { crvAnimal, crvDigiKlauw, crvHerd, crvHerdOptimizer, crvMineral, crvOvalert, crvPhosphatePlanner } from '@v3c/images/icons'

// TODO change url's and labels per MarketCountryCode
// FIXME: Some apps can't set the language based on url-params, per market we'd like to provide a default url including the locale

const baseMenu = [
  {
    id: 'MyCrv',
    label: 'My Crv',
    icon: mdiAccount,
    url: 'https://www.mijncrv.nl',
    isExternal: true,
    hasDividerBellow: true,
  },
  {
    id: 'CrvAnimal',
    label: 'Animal',
    icon: crvAnimal,
    url: 'https://www.crvdier.nl/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvAnalysis',
    label: 'Herd',
    icon: crvHerd,
    url: 'https://crvbedrijf.nl/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvHerdoptimizer',
    label: 'Herdoptimizer',
    icon: crvHerdOptimizer,
    url: 'https://www.crvherdoptimizer.nl/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvMineral',
    label: 'Mineral',
    icon: crvMineral,
    url: 'https://www.crvmineraal.nl/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvPhosphatePlanner',
    label: 'Phosphate Planner',
    icon: crvPhosphatePlanner,
    url: 'https://www.fosfaatplanner.nl/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'DigiClaw',
    label: 'DigiKlauw',
    icon: crvDigiKlauw,
    url: 'https://apps.crv4all.nl/navigation-digiklauw/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvOtherBreeding',
    label: 'Other breeding',
    icon: mdiWeb,
    url: 'https://apps.crv4all.nl/navigation-sap/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvMprFertility',
    label: 'MPR Fertility',
    icon: mdiWeb,
    url: 'https://apps.crv4all.nl/navigation-mprdracht/',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvOvalert',
    label: 'Ovalert',
    icon: crvOvalert,
    url: 'https://apps.crv4all.nl/navigation-ovalert/menu/activiteit-dier',
    isExternal: true,
    hasDividerBellow: false,
  },
  {
    id: 'CrvWebshop',
    label: 'Webshop',
    icon: mdiCart,
    url: 'https://shop.crv4all.nl/nl',
    isExternal: true,
    hasDividerBellow: false,
  },
]


const overrides = {
    NL: {
      prd: {
        MyCrv: {
          label: 'Mijn CRV',
          url: 'https://www.mijncrv.nl',
        },
        CrvAnimal: {
          label: 'Dier',
          url: 'https://www.crvdier.nl',
        },
        CrvAnalysis: {
          label: 'Bedrijf',
          url: 'https://www.crvbedrijf.nl/',
        },

        CrvHerdoptimizer: {
          label: 'Fokkerij',
          url: 'https://www.crvherdoptimizer.nl',
        },
        CrvMineral: {
          label: 'Mineraal',
          url: 'https://www.crvmineraal.nl',
        },
        CrvPhosphatePlanner: {
          label: 'Fosfaatplanner',
          url: 'https://www.fosfaatplanner.nl',
        },
        CrvOtherBreeding: {
          label: 'Overige Fokkerij',
          url: 'https://apps.crv4all.nl/navigation-sap/',
        },
        CrvMprFertility: {
          label: 'MPR Dracht',
          url: 'https://apps.crv4all.nl/navigation-mprdracht/',
        },
      },
      dev: {
        MyCrv: {
          label: 'Mijn CRV',
          url: 'https://www.mijncrv.nl',
        },
        CrvAnimal: {
          label: 'Dier',
          url: 'https://www.crvdier.nl',
        },
        CrvAnalysis: {
          label: 'Bedrijf',
          url: 'https://www.crvbedrijf.nl/',
        },

        CrvHerdoptimizer: {
          label: 'Fokkerij',
          url: 'https://www.crvherdoptimizer.nl',
        },
        CrvMineral: {
          label: 'Mineraal',
          url: 'https://www.crvmineraal.nl',
        },
        CrvPhosphatePlanner: {
          label: 'Fosfaatplanner',
          url: 'https://www.fosfaatplanner.nl',
        },
        CrvOtherBreeding: {
          label: 'Overige Fokkerij',
          url: 'https://apps.crv4all.nl/navigation-sap/',
        },
        CrvMprFertility: {
          label: 'MPR Dracht',
          url: 'https://apps.crv4all.nl/navigation-mprdracht/',
        },
      },
    },
    BE: {
      prd: {
        MyCrv: {
          url: 'https://www.mijncrv.be',
        },
        CrvAnimal: {
          url: 'https://www.crvdier.be',
        },
        CrvAnalysis: {
          url: 'https://www.crvbedrijf.be/',
        },

        CrvHerdoptimizer: {
          url: 'https://www.crvherdoptimizer.be',
        },
        CrvOtherBreeding: {
          url: 'https://apps.crv4all.be/navigation-sap/',
        },
        CrvMprFertility: {
          url: 'https://apps.crv4all.be/navigation-mprdracht/',
        },
      },
      dev: {
        MyCrv: {
          url: 'https://www.mijncrv.be',
        },
        CrvAnimal: {
          url: 'https://www.crvdier.be',
        },
        CrvAnalysis: {
          url: 'https://www.crvbedrijf.be/',
        },

        CrvHerdoptimizer: {
          url: 'https://www.crvherdoptimizer.be',
        },
        CrvOtherBreeding: {
          url: 'https://apps.crv4all.be/navigation-sap/',
        },
        CrvMprFertility: {
          url: 'https://apps.crv4all.be/navigation-mprdracht/',
        },
      },
    },
    EN: {
      prd: {
        MyCrv: {
          hidden: true,
        },
      },
      acc: {
        MyCrv: {
          hidden: true,
        },
      },
      tst: {
        MyCrv: {
          hidden: true,
        },
      },
      dev: {
        MyCrv: {
          hidden: true,
        },
      },
    },
    // Add other markets/environments here...
  }


  export const getDefaultMenu = (market = null, env = null) => {
    const fallbackMarket = 'NL'
    const marketOverrides =
      overrides[market]?.[env] ??
      overrides[fallbackMarket]?.[env] ??
      {}
  
    return baseMenu
      .map(item => {
        if (item.isDivider || !item.id) return item
  
        const override = marketOverrides[item.id]
  
        return override ? { ...item, ...override } : item
      })
      .filter(item => {
        return !item.hidden
      })
  }
